import { FC } from 'react';
import { FieldProps, FieldRenderProps } from 'react-final-form';
import { SelectField } from '../SelectField';
import { COUNTRY_OPTIONS, US_COUNTRY_OPTIONS } from './constants';

interface Props extends FieldProps<HTMLInputElement, FieldRenderProps<any>> {
  label?: string;
  name: string;
  usOnly?: boolean;
}

export const CountrySelectField: FC<Props> = ({ label, name, usOnly, ...fieldProps }) => {
  return (
    <SelectField
      label={label}
      name={name}
      options={usOnly ? US_COUNTRY_OPTIONS : COUNTRY_OPTIONS}
      {...fieldProps}
    />
  );
};
